import React from "react";
import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Reliable & Punctual.",
    body: "On time, every time. We plan every move with military precision so your day runs to schedule.",
  },
  {
    n: "02",
    title: "Fully Insured.",
    body: "Total protection for your belongings in transit — from a single item to a full household.",
  },
  {
    n: "03",
    title: "Transparent Pricing.",
    body: "Straight-talking, flat-fee quotes. No hidden costs, no surprise charges at the door.",
  },
  {
    n: "04",
    title: "Professional Team.",
    body: "Vans equipped with tail-lifts, blankets and straps. A crew that treats your items like their own.",
  },
];

export default function Manifesto() {
  return (
    <section id="why" className="bg-[var(--jb-navy)] text-[var(--jb-bone)] py-24 md:py-40 relative overflow-hidden" data-testid="manifesto-section">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="grid md:grid-cols-12 gap-10 mb-16 md:mb-24"
        >
          <div className="md:col-span-1 mono-cap text-[var(--jb-rust)]">(Manifesto)</div>
          <h2 className="md:col-span-9 serif text-[clamp(44px,7vw,112px)] leading-[0.95] tracking-tight">
            Why choose <br />
            <span className="italic text-[var(--jb-rust)]">Jaybliss Logistics.</span>
          </h2>
        </motion.div>

        <div className="border-t border-[var(--jb-bone)]/15">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="grid md:grid-cols-12 gap-8 py-10 md:py-16 border-b border-[var(--jb-bone)]/15 items-start"
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <div className="md:col-span-3 serif text-[clamp(80px,10vw,180px)] leading-[0.8] text-[var(--jb-rust)]">
                {c.n}
              </div>
              <div className="md:col-span-6">
                <h3 className="serif text-[clamp(32px,3.5vw,56px)] leading-[1.05] tracking-tight">
                  {c.title}
                </h3>
              </div>
              <p className="md:col-span-3 text-[15px] leading-[1.65] text-[var(--jb-bone)]/75 md:pt-3">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
